// extracted by mini-css-extract-plugin
module.exports = {"brandName":"LeftPart_brandName__3Z4lm","signUpArrow":"LeftPart_signUpArrow__3nnnY"};